import _ from "lodash";
// Internal
import { getRating } from "../ratingPrimitives";

export const getProjectsOverallProgressCriteriaSet = ({
  criteriaSet,
  ratings,
  subjectId,
  gradingPeriodType,
  termId,
  curriculumType,
}) => {
  // Get that criteria value
  const academicCriteriaValues = _.get(
    criteriaSet,
    "academicCriteriaValues",
    []
  );

  // Get computed rating
  const computedRating = getRating({
    computedRating: true,
    ratings,
    overallGradeSet: criteriaSet,
    subjectId,
    categoryId: null,
    skipIsRemoved: true,
    gradingPeriodType,
    termId,
    curriculumType,
    isProjectCriteria: true,
  });

  // Get overriding rating
  const overRidingRating = getRating({
    computedRating: false,
    ratings,
    overallGradeSet: criteriaSet,
    subjectId,
    categoryId: null,
    skipIsRemoved: true,
    gradingPeriodType,
    termId,
    curriculumType,
    isProjectCriteria: true,
  });

  const value = _.get(computedRating, "value", "-");
  const valueId = _.get(computedRating, "academicCriteriaValue", "-");

  const overRidingValue = _.get(overRidingRating, "value", null);
  const overRidingRatingId = _.get(overRidingRating, "id", null);
  const overRidingValueId = _.get(
    overRidingRating,
    "academicCriteriaValue",
    null
  );

  return {
    ...criteriaSet,
    value,
    valueId,
    overRidingValue,
    overRidingRatingId,
    overRidingValueId,
    // isRemoved represents isFinalGrade dash
    isRemoved: overRidingRatingId ? _.isNil(overRidingValueId) : valueId == "-",
    customAcademicCriteriaValues: academicCriteriaValues,
  };
};
